// FASE 2 · componentes del handoff v3 compartidos por 09/04/05/10.
// Markup y clases del prototipo (App_v3.html). Sin stake ni unidades en
// ninguna card (decisión 1). RADAR solo para alertas EG1 (decisión 3).
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { I, Wordmark } from './ui';
import { useNotificaciones } from './hooks';
import { STT_CLS, STT_TXT, fmtNum, pickLive } from './live';

const Chev = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6E6E73" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6" /></svg>;

// ── header de Inicio: wordmark · campana (punto si hay no leídas) · avatar ──
export function HdBar({ nombre }) {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { unread } = useNotificaciones();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const inicial = (nombre || 'E').trim().charAt(0).toUpperCase();
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', onDown);
    return () => document.removeEventListener('pointerdown', onDown);
  }, [open]);
  return (
    <div className="hd">
      <div className="logo"><Wordmark width={128} /></div>
      <div className="hd-r">
        <button type="button" className={`bell${unread > 0 ? ' dot' : ''}`} aria-label="Notificaciones" onClick={() => navigate('/app/notificaciones')}><I.bell /></button>
        <div className="avwrap" ref={ref}>
          <button type="button" className="av" aria-label="Menú de cuenta" aria-expanded={open} onClick={() => setOpen((o) => !o)}>{inicial}</button>
          {open && (
            <div className="app-avmenu" role="menu">
              <button type="button" role="menuitem" onClick={() => { setOpen(false); navigate('/app/perfil'); }}>Mi perfil</button>
              <button type="button" role="menuitem" className="neg" onClick={async () => { setOpen(false); await signOut(); navigate('/app'); }}>Cerrar sesión</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── ticker (28s loop, pausa al tocar) ──
export function Ticker({ items }) {
  const [paused, setPaused] = useState(false);
  if (!items || !items.length) return null;
  const doble = [...items, ...items];
  return (
    <div className={`ticker${paused ? ' paused' : ''}`} aria-label="Actividad en vivo"
      onPointerDown={() => setPaused(true)} onPointerUp={() => setPaused(false)} onPointerCancel={() => setPaused(false)}>
      <div className="trk">
        {doble.map((it, i) => (
          <span key={i} className={`tk${it.dk ? ' dk' : ''}`}>
            <i className={`dot${it.dot ? ` ${it.dot}` : ''}`} />
            {it.a}
            {it.sc && <span className="sc">{it.sc}</span>}
            {it.b && <>{' '}{it.b}</>}
            {it.sc2 && <span className="sc">{it.sc2}</span>}
            {it.ed && <span className={`ed${it.edCls ? ` ${it.edCls}` : ''}`}>{it.ed}</span>}
          </span>
        ))}
      </div>
    </div>
  );
}

// ── motor compacto A ──
export function MotorA({ nLive, nEntrar, nVigilar, offline }) {
  const vacio = nLive === 0;
  return (
    <div className="motor-a">
      <div className="pulse"><i className={offline ? 'off' : ''} /></div>
      <div className="b">
        <p className={`k${offline ? ' off' : ''}`}>Motor V6.1<span>{offline ? 'Pausado' : 'Live'}</span></p>
        {offline ? <p className="t">Sin conexión con el motor</p>
          : vacio ? <p className="t">Escaneando. <em>Sin acción todavía</em></p>
          : <p className="t">Analizando <em>{nLive} partido{nLive === 1 ? '' : 's'} en vivo</em></p>}
      </div>
      <div className="cnt">
        <div><p className={`n${nEntrar ? '' : ' z'}`}>{nEntrar}</p><p className="l"><i />Entrar</p></div>
        <div><p className={`n${nVigilar ? '' : ' z'}`}>{nVigilar}</p><p className="l w"><i />Vigilar</p></div>
      </div>
    </div>
  );
}

// Pie de la card en vivo según estado (copy del prototipo 09A / 04·análisis)
function pieDe(l) {
  if (l.sinLinea) return { pk: <>Esperando línea de la casa</> };
  if (l.estado === 'ENTRAR') return { pk: <><b>{pickLive(l)}</b> · Proy. {Math.round(l.proyeccion)}</> };
  if (l.estado === 'VIGILAR') return { pk: <>Umbral en <b>{fmtNum(l.umbral)}</b></> };
  if (l.estado === 'TEMPRANO') return { pk: <>Muestra insuficiente · desde {l.esHb ? 'min 34' : 'Q2'}</> };
  return { pk: <>Edge <b>{fmtNum(l.edge)}</b> · sin acción</> };
}

// ── card de partido en vivo `.lv` (carrusel 262px o .full) ──
export function LvCard({ l, full = false }) {
  const navigate = useNavigate();
  const m = l.marcador;
  const leadA = m.away != null && m.home != null && m.away > m.home;
  const leadH = m.away != null && m.home != null && m.home > m.away;
  const { pk } = pieDe(l);
  const sttCls = l.estado === 'ENTRAR' || l.estado === 'VIGILAR' ? STT_CLS[l.estado] : 'n';
  const sttTxt = l.estado === 'ENTRAR' || l.estado === 'VIGILAR' ? STT_TXT[l.estado] : 'Análisis';
  return (
    <button type="button" className={`lv${full ? ' full' : ''}`} onClick={() => navigate(`/app/partido/${l.gid}`)}>
      <div className="lv-t"><span className="lvb"><i />Live</span><span className="lg">{l.liga}</span><span className="q">{l.tiempo}</span></div>
      <div className="teams" style={{ '--gp': `${l.gp}%` }}>
        <div className={`tm${leadA ? ' lead' : ''}`}><span>{l.away}</span><span className="sc">{m.away ?? '–'}</span></div>
        <div className={`tm${leadH ? ' lead' : ''}`}><span>{l.home}</span><span className="sc">{m.home ?? '–'}</span></div>
      </div>
      <div className="lv-f">
        <span className={`stt ${sttCls}`}><i />{sttTxt}</span>
        <span className="pk">{pk}</span>
        {l.edge != null && !l.sinLinea && <span className="v3edge">{fmtNum(l.edge)}</span>}
      </div>
    </button>
  );
}

// ── card de señal `.sig` genérica ──
// chip: { kind: 'stt', cls, txt } | { kind: 'sport', txt }
// cols: [{ l, v, cls, res }]  (res = 'w'|'l'|'p' pinta .res-tag)
export function SigCard({ liga, live, chip, edge, away, home, cols, onClick }) {
  return (
    <button type="button" className={`sig${live ? ' live-sig' : ''}`} onClick={onClick}>
      <div className="sig-t">
        <span className="lg">{liga}</span>
        {chip && chip.kind === 'stt' && <span className={`stt ${chip.cls}`}><i />{chip.txt}</span>}
        {chip && chip.kind === 'sport' && <span className="sport">{chip.txt}</span>}
        {edge != null && <span className="v3edge">Edge {fmtNum(edge)}</span>}
      </div>
      <p className="match">{away}<span className="vs">vs</span>{home}</p>
      <div className="sig-meta">
        {cols.map((c, i) => (
          <div className="c" key={i}>
            <p className="l">{c.l}</p>
            {c.res ? <p className={`res-tag ${c.res}`}>{c.v}</p> : <p className={`v${c.cls ? ` ${c.cls}` : ''}`}>{c.v}</p>}
          </div>
        ))}
        <div className="arw"><Chev /></div>
      </div>
    </button>
  );
}

// ── fila de próximo partido `.up` (Agenda / Inicio) ──
export function UpRow({ g, esHoy, on, onBell, fecha, disabled }) {
  const vivo = g.estado === 'en_vivo';
  const fin = g.estado === 'finalizado';
  return (
    <div className="up" style={fin ? { opacity: .55 } : undefined}>
      <div className="when"><b>{g.hora || '—'}</b><span>{vivo ? 'vivo' : fin ? 'final' : esHoy ? 'hoy' : ''}</span></div>
      <div className="b">
        <p className="lg"><span className="lg">{g.liga || '—'}</span><span style={{ fontSize: 11 }}>{g.esHandball ? '🤾' : '🏀'}</span></p>
        <p className="m">{g.home} vs {g.away}</p>
      </div>
      <span className={`cov${g.cobertura ? '' : ' n'}`} title={g.cobertura ? 'Cobertura del motor' : 'Sin cobertura'}><i /></span>
      <button type="button" className={`bellb${on ? ' on' : ''}`} aria-label="Recordatorio 10 min antes"
        disabled={disabled || !g.cobertura || fin} onClick={() => onBell && onBell(g.gid, { hora: g.hora, partido: `${g.home} vs ${g.away}`, fecha })}>
        <I.bell width={14} height={14} stroke={on ? '#FF4D0D' : '#6E6E73'} strokeWidth="2.2" />
      </button>
    </div>
  );
}

// ── últimos 10 días `.streak` (sin texto de conteo) ──
export function Streak({ days }) {
  if (!days || !days.length) return null;
  const maxAbs = Math.max(1, ...days.map((d) => Math.abs(d.net)));
  return (
    <div className="streak">
      <div className="streak-t"><span className="lbl">Racha actual</span></div>
      <div className="bars">
        {days.map((d) => {
          const h = d.decided === 0 ? 22 : Math.max(30, Math.round((Math.abs(d.net) / maxAbs) * 100));
          const cls = d.decided === 0 ? 'n' : d.net < 0 ? 'l' : '';
          return <span key={d.dayStr} className={cls} style={{ height: `${h}%` }} />;
        })}
      </div>
      <div className="days">{days.map((d) => <span key={d.dayStr}>{d.label}</span>)}</div>
    </div>
  );
}

// ── sin acceso: informativo, sin precio ni CTA de pago (decisión 5) ──
export function NoAccess({ que }) {
  return (
    <div className="noacc">
      <h3>Tu acceso no está activo</h3>
      <p>{que || 'Con el acceso activo ves todas las señales del día, el historial completo y el detalle de cada partido.'} La activación se gestiona desde la web de Edge Elite, no desde la app.</p>
    </div>
  );
}
